import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CacheService } from './cache.service';
import { jhcassoAPIUri } from 'src/environments/apiUri';
import { BehaviorSubject } from 'rxjs';
import { ProfileData, ProfileInfoResponse } from '../models/Response/ProfileResponse';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private profileSubject = new BehaviorSubject<ProfileData | null>(null);
  profile$ = this.profileSubject.asObservable();

  constructor(
    private api: ApiService,
    private cache: CacheService
  ) {
    // 🔥 Load cached profile instantly on service init
    const cachedProfile = this.cache.get('userProfile');
    if (cachedProfile) {
      this.profileSubject.next(cachedProfile);
    }
  }

  loadProfile() {
    return this.api.get(jhcassoAPIUri.profile).subscribe(
      (res: ProfileInfoResponse) => {
        if (res.status) {
          this.cache.set('userProfile', res.data);
          this.profileSubject.next(res.data);
        }
      }
    );
  }

  getProfile(): ProfileData | null {
    return this.cache.get('userProfile');
  }

  updateProfileLocally(data: ProfileData) {
    this.cache.set('userProfile', data);
    this.profileSubject.next(data);
  }

  clearProfile() {
    this.cache.remove('userProfile');
    this.profileSubject.next(null);
  }
}